export default "__VITE_ASSET__B_OH0frF__"